















































































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import ShiftDto from '@/models/Shifts/ShiftDto';
import ShiftViewModel from '@/models/Shifts/ShiftViewModel';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import BreakDto from '@/models/Shared/BreakDto';
import DateTimeUtils from '@/lib/dateTimeUtils';

@Component({
    name: 'BookingDetailsShiftEdit'
})
export default class extends GiganautVueDialog {
 
    @Prop({required: true})
    public shift: ShiftDto;
    public dialog = false;
    public entity = new ShiftViewModel();

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            await BookingDetailsModule.getNewBookingOptions();
            const vm: ShiftViewModel = new ShiftViewModel();
            vm.id = this.shift.id;
            vm.updatedAt = this.shift.updatedAt;
            vm.bookingRoleId = this.shift.bookingRoleId;
            vm.startAtTime = new Date(this.shift.startAt).toLocaleTimeString();
            vm.startAtDate = DateTimeUtils.toYYMMDD(new Date(this.shift.startAt));
            vm.endAtTime = new Date(this.shift.endAt).toLocaleTimeString();
            vm.quantity = this.shift.quantity;
            vm.break = this.shift.break;//BookingDetailsModule.newBookingOptions.breaks.find(b => b.minutes = this.shift.break);
            vm.isPaidBreak = this.shift.isPaidBreak;
            this.entity = vm;
        }
    }

    get breaks() {
        return BookingDetailsModule.newBookingOptions.breaks;
    }

    get loading() {
        return BookingDetailsModule.loadingDialog;
    }

    save() {
        BookingDetailsModule.editShift(this.entity);
        this.dialog = false;
    }
}
